/* eslint-disable react-hooks/exhaustive-deps */
import { formatDate, formatDateForConversationMessage } from "helpers/utils"

import { ReactComponent as ArrowLeftIcon } from "assets/images/icons/arrow-left.svg"

import { useEffect, useState } from "react"
import {
  CONVERSATION_ROLE,
  ConversationDetail,
  ConversationMessagesDetail,
  MENU_TAB_CONVERSATION,
  MENU_TAB_KEY,
  STATUS_CONVERSATION,
} from "../conversations.type"
import {
  BUILD_INVITEE_STATUS,
  InviteeBuilComponentDetail,
  MENU_TAB_BUILD,
  ProjectBuildAdditionalDetail,
} from "pages/project-build/project-build.type"
import {
  onRedirectConversationComponent,
  projectBuildLink,
} from "helpers/redirect"
import SwitchButtonDefault from "components/SwitchButton/SwitchButtonDefault"
import { ProjectComponentStatus, STATUS_BUILD } from "components/Status/types"
import {
  IUseDefaultValueProps,
  useBoolean,
  useString,
  useWindowSize,
} from "helpers/hooks"
import LabelHeader, {
  getContentLabelStyleProps,
} from "pages/project-component/molecules/LabelHeader"
import ActivityLogDefault from "components/activity-log/ActivityLogDefault"
import { MODEL_ACTIVITY_LOG } from "components/activity-log/activity-log.type"
import { twMerge } from "tailwind-merge"
import InfoNameAndEmailConversationCard from "../atoms/InfoNameAndEmailConversationCard"
import StatusConversationCard from "../atoms/StatusConversationCard"
import ActionIconHistory from "pages/project-component-detail/molecules/ActionIconHistory"
import ComponentBuildItemCard2 from "pages/project-build/molecules/ComponentBuildItemCard2"
import TabCoversationDetail from "./TabCoversationDetail"
import AdditionalInfoCard from "pages/project-build/organisms/AdditionalInfoCard"
import MenuTabConversationCard from "../molecules/MenuTabConversationCard"
import LabelStatusBuild from "pages/project-component/molecules/LabelStatusBuild"
import { getProjectBuildAdditionalInfoMiddleware } from "pages/project-build/api.services"
import { useAppSelector } from "hooks/useApp"
import { cloneDeep, includes, isEmpty, orderBy } from "lodash"
import { useTippyLayout } from "components/TippyCustomzie"
import { HeaderContent } from "components/HeaderInfo/HeaderInfo"
import { ReactComponent as CollapseIcon } from "assets/images/icons/collapse-icon.svg"
import { ReactComponent as ExpandIcon } from "assets/images/icons/expand-icon.svg"
import { ReactComponent as IconLock } from "assets/images/icons/icon-lock.svg"
import { getWorkerLocalStorageData } from "workers/utils"
import { getConversationMessagesMiddleware } from "../conversations.api"
import { downloadQueueManager } from "components/DownloadProcess/downloadQueue"
import { v4 as uuid } from "uuid"
import { toast } from "react-toastify"
import LabelNotificationPage from "components/Notification/LabelNotificationPage"
import { configureStore } from "stores/configureStore"
import { closeLoading, startLoading } from "reducers/loading"

interface Props {
  conversationInfo: ConversationDetail
  conversationMessages: ConversationMessagesDetail
  activeIdConversation: string
  activeIdBuild: string
  isChangeScrollMessageBottom: {
    value: boolean
    setValue: (value: boolean) => void
  }

  updateWhenAddMessager: (newMessage: string) => void
  getConversationMessages: (
    conversationId: string,
    dbKey: string,
    setConversation: boolean,
    loading: boolean
  ) => Promise<void>
  isNotificationMessage: boolean
  onChangeNotification: (originNotification: boolean) => () => void
  isConversationUnActive: boolean
  isDeleted?: boolean
  closeLayout: IUseDefaultValueProps
  collapse: IUseDefaultValueProps
  isWarningEncrypted: boolean
  isMoreDataMessage: {
    value: boolean
    setValue: (value: boolean) => void
  }
  rowsMessagePerPageHook: {
    value: number
    setValue: (value: number) => void
  }
  selectedConversation: ConversationDetail
  pageMessageHook: {
    value: number
    setValue: (value: number) => void
  }
  setConversationMessages: (newValue: ConversationMessagesDetail) => void
  organizationActive: {
    value: string
    setValue: (value: string) => void
  }
}
const ConversationMessagesColumn = (props: Props) => {
  const userInfo = useAppSelector((state) => state.userInfo)
  const {
    conversationMessages,
    conversationInfo,
    activeIdConversation,
    isChangeScrollMessageBottom,
    isNotificationMessage,
    isConversationUnActive,
    updateWhenAddMessager,
    onChangeNotification,
    isDeleted,
    getConversationMessages,
    closeLayout,
    collapse,
    isWarningEncrypted,
    isMoreDataMessage,
    rowsMessagePerPageHook,
    selectedConversation,
    pageMessageHook,
    setConversationMessages,
    organizationActive,
  } = props
  const { isMobile } = useWindowSize()
  const [additionals, setAdditionals] = useState<
    ProjectBuildAdditionalDetail[]
  >([])
  const activeTab = useString(MENU_TAB_BUILD.CONVERSATION)
  const isLoading = useBoolean()
  const contentLabelStyleProps = getContentLabelStyleProps(!isMobile)
  const showProjectInfo = useBoolean()
  const { TippyLayout /* closeLayout, openLayout  */ } = useTippyLayout()
  const isToggle = useBoolean()
  const { currentProjectEncryptionKey } = getWorkerLocalStorageData()
  const isLoadingMoreDataMessage = useBoolean(false)
  const isRenderScroll = useBoolean(false)
  const isProject = !!(
    !isEmpty(conversationInfo.project_id) &&
    includes(
      [
        MENU_TAB_KEY[MENU_TAB_CONVERSATION.OTHERS],
        MENU_TAB_KEY[MENU_TAB_CONVERSATION.FROM_ME],
      ],
      conversationInfo.tab
    ) &&
    userInfo.last_organization_id &&
    conversationInfo.organization?.id &&
    conversationInfo.organization?.id === userInfo.last_organization_id
  )
  const isBuild = !!(
    !isEmpty(conversationInfo.project_build_id) &&
    includes(
      [
        MENU_TAB_KEY[MENU_TAB_CONVERSATION.OTHERS],
        MENU_TAB_KEY[MENU_TAB_CONVERSATION.FROM_ME],
      ],
      conversationInfo.tab
    ) &&
    userInfo.last_organization_id &&
    conversationInfo.organization?.id &&
    conversationInfo.organization?.id === userInfo.last_organization_id
  )
  useEffect(() => {
    if (!organizationActive.value) {
      return
    }
    // getAdditional(organizationActive.value, true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conversationInfo.id, organizationActive.value])

  const onChangeTab = (_newIndex: number, newLabel?: string) => () => {
    if (!newLabel) {
      return
    }
    if (activeTab.value === newLabel) {
      return
    }
    activeTab.setValue(newLabel)
    isLoading.setValue(true)
    if (newLabel === MENU_TAB_BUILD.CONVERSATION && organizationActive.value) {
      getConversationMessages(
        conversationInfo.id,
        organizationActive.value,
        true,
        true
      )
      return
    }
    if (newLabel === MENU_TAB_BUILD.ADDITIONAL) {
      getAdditional(organizationActive.value, true)
    }
  }
  const getAdditional = async (newDbKey: string, loading = false) => {
    const dataAdditionalRes = await getProjectBuildAdditionalInfoMiddleware(
      conversationInfo.project_build_id,
      conversationInfo.id,
      newDbKey
    )
    setAdditionals(dataAdditionalRes)
    if (loading) {
      isLoading.setValue(false)
    }
  }
  const onExportFile = async () => {
    if (!conversationInfo.id) {
      return
    }
    isLoading.setValue(true)

    downloadQueueManager.add({
      apiURL: `/api/project-build/${conversationInfo.project_build_id}/files?conversation_id=${conversationInfo.id}&project_id=${conversationInfo.project_id}&loading=0`,
      name: conversationInfo.code,
      subName: `Conversation: ${conversationInfo.code}`,
      buildId: conversationInfo.project_build_id,
      downloadId: uuid(),
      dbKey: organizationActive.value,
    })
  }
  const onClickRootBuildComponent =
    (oldComponent: InviteeBuilComponentDetail) => () => {
      if (isConversationUnActive) return
      if (!oldComponent.is_read || !oldComponent.is_read_invitee_commit) {
        const newConversationMessage = cloneDeep(conversationMessages)
        newConversationMessage.components.forEach((component) => {
          if (
            component.project_component_id === oldComponent.project_component_id
          ) {
            component.is_read = true
            component.is_read_invitee_commit = true
          }
        })
        setConversationMessages(newConversationMessage)
      }
      onRedirectConversationComponent(
        oldComponent.type_key,
        oldComponent.project_component_id,
        oldComponent.project_build_component_id,
        oldComponent.project_component_history_id,
        activeIdConversation,
        !isConversationUnActive,
        undefined,
        true,
        organizationActive.value
      )
    }

  const onScrollMessage = async (commentFromScrollId?: string) => {
    if (!commentFromScrollId) {
      if (!isMoreDataMessage.value || isLoadingMoreDataMessage.value) {
        return
      }
      isLoadingMoreDataMessage.setValue(true)
      const params = {
        page: pageMessageHook.value + 1,
        pageSize: rowsMessagePerPageHook.value,
      }
      const dataRes = await getConversationMessagesMiddleware(
        selectedConversation.id,
        organizationActive.value,
        params
      )
      const newConversationMessage = cloneDeep(conversationMessages)
      newConversationMessage.messages = orderBy(
        dataRes.messages as any,
        "created_at",
        "asc"
      ).concat(conversationMessages.messages)
      setConversationMessages(newConversationMessage)
      pageMessageHook.setValue(pageMessageHook.value + 1)
      isMoreDataMessage.setValue(
        dataRes.messages.length < rowsMessagePerPageHook.value ? false : true
      )
      isLoadingMoreDataMessage.setValue(false)
      isRenderScroll.setValue(true)
    } else {
      if (!isMoreDataMessage.value) {
        toast(
          <LabelNotificationPage
            messenger="Reply message not found"
            type="warning"
          />
        )
        return
      }
      let isLoaded = true
      let newPage = pageMessageHook.value
      let newCommentFrom: any = null
      let messagesResult: any = []
      let newMoreData = false
      configureStore.dispatch(startLoading())
      do {
        const params = {
          page: newPage + 1,
          pageSize: rowsMessagePerPageHook.value,
        }
        newPage = newPage + 1
        const dataRes = await getConversationMessagesMiddleware(
          selectedConversation.id,
          organizationActive.value,
          params,
          true
        )
        const newMessages = dataRes.messages as any[]
        newCommentFrom = newMessages?.find(el => el.id === commentFromScrollId)
        newMoreData = newMessages.length < rowsMessagePerPageHook.value ? false : true
        messagesResult = messagesResult.concat(newMessages)
        if (newCommentFrom || !newMoreData) {
          isLoaded = false
        }
      } while (isLoaded);
      const newConversationMessage = cloneDeep(conversationMessages)
      newConversationMessage.messages = orderBy(
        messagesResult,
        "created_at",
        "asc"
      ).concat(conversationMessages.messages)
      setConversationMessages(newConversationMessage)
      pageMessageHook.setValue(newPage)
      isMoreDataMessage.setValue(newMoreData)
      setTimeout(() => {
        closeLoading()
        if (newCommentFrom) {
          const el = document.getElementById(`msg-${commentFromScrollId}`);
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            el.classList.add('highlight-message');
            setTimeout(() => el.classList.remove('highlight-message'), 2500);
          }
        } else {
          toast(
            <LabelNotificationPage
              messenger="Reply message not found"
              type="warning"
            />
          )
        }
      }, 500)

    }

  }

  const renderBuildAndEmailAction = () =>
    !(
      conversationInfo.tab === "others" || conversationInfo.is_archived_by_owner
    ) && (
      <div className="flex items-center justify-between ">
        <SwitchButtonDefault
          containerClass="ml-2"
          checked={isNotificationMessage}
          disabled={
            conversationInfo.tab === "others" ||
              conversationInfo.is_archived_by_owner
              ? true
              : false
          }
          labelButton="Email notification"
          onChange={onChangeNotification(isNotificationMessage)}
        />
      </div>
    )
  const renderHeader = () => (
    <div className="flex justify-between border-solid border-b-[1px] border-brown h-[48px] pr-6">
      <div className="flex justify-between">
        <LabelHeader
          title="Convo ID:"
          label={`${conversationInfo.code}`}
          isBorderRight={
            conversationInfo.invitee_status !== BUILD_INVITEE_STATUS.DEACTIVATE
          }
        />
        {conversationInfo.invitee_status !==
          BUILD_INVITEE_STATUS.DEACTIVATE && (
            <div className="flex items-center">
              <p className="font-normal leading-[22px] text-[13px]">
                Build status:{" "}
              </p>
              <LabelStatusBuild
                status={
                  conversationInfo.project_build_status || STATUS_BUILD.DRAFT
                }
                rootStyle={{
                  fontSize: 13,
                  lineHeight: "22px",
                  marginLeft: "4px",
                }}
              />
            </div>
          )}
      </div>
      <div className="flex items-center">
        <LabelHeader
          title="Project ID:"
          label={`${conversationInfo.project_code}`}
          isBorderRight={true}
          isClick={isProject}
          path={`/project-detail/${conversationInfo.project_id}`}
        />

        <LabelHeader
          title="Build ID:"
          label={`${conversationInfo.project_build_code}`}
          isBorderRight={true}
          isClick={isBuild}
          path={projectBuildLink(
            conversationInfo.project_id,
            conversationInfo.project_build_id,
            conversationInfo.project_build_status
          )}
          search={{
            tab: conversationInfo.from === userInfo.id ? "my-builds" : "others",
          }}
        />

        <LabelHeader
          title="Created:"
          label={formatDate(conversationInfo.created_at, "DD MMM yyyy")}
          isBorderRight={conversationInfo.updated_at ? true : false}
        />
        {conversationInfo.updated_at ? <LabelHeader
          title="Last message:"
          label={`${formatDateForConversationMessage(
            conversationInfo.updated_at
          )}`}
          isBorderRight={
            currentProjectEncryptionKey &&
              currentProjectEncryptionKey.length === 64 &&
              conversationMessages.is_owner
              ? true
              : false
          }
        /> : null}

        {currentProjectEncryptionKey &&
          currentProjectEncryptionKey.length === 64 &&
          conversationMessages.is_owner && (
            <ActivityLogDefault
              model={MODEL_ACTIVITY_LOG.CONVERSATION_BUILDS}
              idRelation={conversationInfo.id}
              dbKey={organizationActive.value}
            />
          )}
      </div>
    </div>
  )
  const headerMobileContent = () => {
    return (
      <>
        <LabelHeader
          {...contentLabelStyleProps}
          title="Project ID:"
          label={`${conversationInfo.project_code}`}
          isClick={isProject}
          path={`/project-detail/${conversationInfo.project_id}`}
        />

        <LabelHeader
          {...contentLabelStyleProps}
          title="Build ID:"
          label={`${conversationInfo.project_build_code}`}
          isClick={isBuild}
          path={projectBuildLink(
            conversationInfo.project_id,
            conversationInfo.project_build_id,
            conversationInfo.project_build_status
          )}
          search={{
            tab: conversationInfo.from === userInfo.id ? "my-builds" : "others",
          }}
        />
        <div className="flex items-center justify-between h-[52px] md:h-[13px] w-full border-b-[1px] first-item-border-top md:border-none">
          <div className="flex items-end md:items-center justify-between flex-1">
            <p className="font-normal text-sm md:text-[13px] leading-[22px] whitespace-nowrap overflow-hidden px-6 md:px-0 text-new-black-333333">
              Build status:{" "}
            </p>
            <LabelStatusBuild
              status={
                conversationInfo.project_build_status || STATUS_BUILD.DRAFT
              }
              rootStyle={{
                fontSize: 13,
                lineHeight: "22px",
                marginLeft: "4px",
              }}
              className="px-6"
            />
          </div>
        </div>
        <LabelHeader
          {...contentLabelStyleProps}
          title="Convo ID:"
          label={`${conversationInfo.code}`}
        />

        <LabelHeader
          {...contentLabelStyleProps}
          title="Created:"
          label={formatDate(conversationInfo.created_at, "DD MMM yyyy")}
          isBorderRight={conversationInfo.updated_at ? true : false}
        />
        {conversationInfo.updated_at ? <LabelHeader
          {...contentLabelStyleProps}
          title="Last message:"
          label={`${formatDateForConversationMessage(
            conversationInfo.updated_at
          )}`}
        /> : null}
      </>
    )
  }
  const renderHeaderMobile = () => (
    <TippyLayout
      visible={showProjectInfo.value}
      headerContent={
        <HeaderContent onClick={() => showProjectInfo.setValue(false)} />
      }
      mainContent={headerMobileContent()}
      allowHTML={true}
    >
      <div className="flex items-center justify-between border-b-[1px] border-brown pl-[4px]">
        <div
          className="flex p-2"
          onClick={() => {
            closeLayout.setValue(false)
          }}
        >
          <ArrowLeftIcon />
        </div>
        <div className="flex justify-end md:justify-between items-center h-full px-[12px] py-3">
          <LabelHeader
            title="Project Info"
            isBorderRight={
              currentProjectEncryptionKey &&
                currentProjectEncryptionKey.length === 64 &&
                conversationMessages.is_owner
                ? true
                : false
            }
            onClickTitle={() => {
              showProjectInfo.setValue(true)
            }}
          />
          {currentProjectEncryptionKey &&
            currentProjectEncryptionKey.length === 64 &&
            conversationMessages.is_owner && (
              <ActivityLogDefault
                model={MODEL_ACTIVITY_LOG.CONVERSATION_BUILDS}
                idRelation={conversationInfo.id}
                dbKey={organizationActive.value}
              />
            )}
        </div>
      </div>
    </TippyLayout>
  )
  const renderParticipantInfo = () => {
    const className =
      "flex flex-col md:mt-3 md:flex-row items-start md:items-center gap-y-3 gap-x-6 md:gap-y-0"
    return (
      <div className={twMerge("justify-between ", className)}>
        <div className="flex flex-col pr-6 border-none gap">
          <InfoNameAndEmailConversationCard
            name={conversationMessages.owner.fullname}
            email={conversationMessages.owner.email}
            label="From:"
          />
          <InfoNameAndEmailConversationCard
            name={conversationMessages.invitee.name}
            email={conversationMessages.invitee.email || "N/A"}
            label="To:"
          />
        </div>
        {/* CC LIST */}
        <div className="h-[44px] ">
          <div className="flex items-center max-w-[400px] overflow-hidden align-top ">
            <p
              className="font-normal text-13 leading-22 color-gray-7a"
              style={{
                width: 48,
              }}
            >
              {"CC:"}
            </p>
            <div className="flex flex-wrap gap-x-[1px] overflow-hidden">
              {conversationInfo.cc.length === 0 ? (
                <p className="font-normal text-13 leading-22 color-gray-7a">
                  N/A
                </p>
              ) : (
                conversationInfo.cc.map((email, index) => (
                  <p
                    className="font-normal text-13 leading-22 color-gray-7a"
                    key={index}
                  >
                    {email}
                    {index !== conversationInfo.cc.length - 1 ? "," : ""}
                  </p>
                ))
              )}
            </div>
          </div>
        </div>

        <div className="hidden md:flex gap-1 items-center md:border-solid md:border-l-[1px] md:border-[#E4E4E4] md:pr-3">
          <StatusConversationCard status={Boolean(conversationInfo.is_archived_by_me) ? STATUS_CONVERSATION.CLOSED : conversationInfo.status} />
          {!isConversationUnActive && (
            <ActionIconHistory
              icon="download"
              tooltip="Download"
              styleIcon={{
                margin: 0,
              }}
              onClick={onExportFile}
              classIcon="hidden md:flex action-icon-download-conversation"
            />
          )}
        </div>
      </div>
    )
  }

  const renderConvoDetailOnMobile = () => (
    <div className="flex flex-col">
      <div className="flex justify-between items-center pl-[12px]">
        <div className="flex flex-col">
          <InfoNameAndEmailConversationCard
            name={conversationMessages.owner.fullname}
            email={conversationMessages.owner.email}
            label="From:"
          />
          <InfoNameAndEmailConversationCard
            name={conversationMessages.invitee.name}
            email={conversationMessages.invitee.email || "N/A"}
            label="To:"
          />
        </div>
        <div className="pl-2 border-l-[1px] border-[#E4E4E4] ml-[4px]">
          <StatusConversationCard status={conversationInfo.status} />
        </div>
      </div>
      <div className="px-[12px] mt-[4px]">
        <p className="font-normal text-13 leading-22 color-gray-7a whitespace-nowrap overflow-hidden text-ellipsis">
          {`CC: ${conversationInfo.cc.map((email) => email).join(", ")}`}
        </p>
      </div>
    </div>
  )
  const renderMenuTab = () => {
    return (
      <div className="border-solid border-t-[1px] border-brown mt-[12px]">
        <div className="flex justify-between items-center pr-6">
          <MenuTabConversationCard
            onChangeTab={onChangeTab}
            activeTab={activeTab.value}
            additional={{
              isRead: false,
              count: conversationInfo.additional_count,
            }}
            conversation={{
              count: conversationMessages.total_message,
              isRead: false,
            }}
            isDeactivated={
              conversationInfo.invitee_status ===
              BUILD_INVITEE_STATUS.DEACTIVATE
            }
            component={{
              isRead: false,
              count: conversationInfo.components?.length || 0,
            }}
          />
          <div className="hidden md:block">{renderBuildAndEmailAction()}</div>
        </div>
      </div>
    )
  }
  const renderTab = () => {
    if (activeTab.value === MENU_TAB_BUILD.CONVERSATION) {
      return (
        <TabCoversationDetail
          idConversation={activeIdConversation}
          originMessages={conversationMessages.messages}
          projectId={conversationInfo.project_id}
          // only invitee is able to chat
          isEditorInput={
            !(
              isConversationUnActive ||
              (conversationInfo.role === CONVERSATION_ROLE.VIEWER &&
                //incase invitee is the viewer
                conversationInfo.invitee.user_id !== userInfo.id)
            )
          }
          updateWhenAddMessager={updateWhenAddMessager}
          inviteeUser={conversationMessages.invitee}
          owner={conversationMessages.owner}
          onScrollMessage={onScrollMessage}
          isChangeScrollMessageBottom={isChangeScrollMessageBottom}
          isDeleted={isDeleted}
          notYetCommented={conversationMessages.is_not_yet_commented_by_users}
          disableButtonEditor={
            conversationInfo.invitee_status === BUILD_INVITEE_STATUS.DEACTIVATE
          }
          isLoadingMessage={isMoreDataMessage.value}
          isRenderScroll={isRenderScroll}
          subNameDownload={`Conversation: ${conversationInfo.code}`}
          collapseComponent={true}
          organizationActive={organizationActive}
        />
      )
    }
    if (activeTab.value === MENU_TAB_BUILD.COMPONENT) {
      return (
        <div
          className="flex flex-wrap items-start gap-3 overflow-auto h-full"
          style={{ alignContent: "flex-start" }}
        >
          {conversationMessages.components.map((buildComponent, index) => {
            return (
              <ComponentBuildItemCard2
                key={index}
                component={buildComponent}
                onClickRoot={onClickRootBuildComponent}
                isDeleted={
                  isDeleted ||
                  buildComponent.status ===
                  ProjectComponentStatus.DeletedAttachment
                }
                isDisabled={!!isConversationUnActive}
                tooltip={
                  !buildComponent.is_read_invitee_commit ? (
                    <span
                      className="font-normal"
                      style={{
                        fontSize: 13,
                        lineHeight: "22px",
                        wordBreak: "break-word",
                      }}
                    >
                      Invitee submitted a new version of this component.
                    </span>
                  ) : null
                }
              />
            )
          })}
        </div>
      )
    }

    return (
      <AdditionalInfoCard
        isLabel={false}
        additionals={additionals}
        idProjectBuild={conversationInfo.project_build_id}
        updateWhenCreateAdditional={() => undefined}
        updateWhenDeleteAdditional={() => undefined}
        isDeleteComment={true}
        isEditorInput={true}
        isDeleted={isDeleted}
        conversationId={conversationInfo.id}
        subNameDownload={`Additional info: ${conversationInfo.project_build_code}`}
        styleRoot={{
          overflow: "auto",
        }}
        collapseComponent={true}
      />
    )
  }

  const renderBody = () => {
    if (isMobile) {
      return (
        <div className="flex-1 h-full flex flex-col bg-white">
          <div
            className={`flex flex-col w-full gap-2  ${isToggle.value ? "z-[101]" : ""
              }`}
            style={{
              background: "#FFFFFF",
            }}
          >
            {renderHeaderMobile()}
            {renderConvoDetailOnMobile()}
          </div>
          <div className="flex justify-between items-center pl-[12px]">
            <MenuTabConversationCard
              onChangeTab={onChangeTab}
              activeTab={activeTab.value}
              additional={{
                isRead: false,
                count: conversationInfo.additional_count,
              }}
              conversation={{
                count: conversationMessages.total_message,
                isRead: false,
              }}
              isDeactivated={
                conversationInfo.invitee_status ===
                BUILD_INVITEE_STATUS.DEACTIVATE
              }
              component={{
                isRead: false,
                count: conversationInfo.components?.length || 0,
              }}
            />
            <div className="hidden md:block">{renderBuildAndEmailAction()}</div>
          </div>
          <div className="flex-1 overflow-hidden pl-[12px]">{renderTab()}</div>
        </div>
      )
    }
    return (
      <div className="flex-1 h-full flex flex-col justify-between bg-white pl-6">
        <div
          className={`flex flex-col w-full gap-2${isToggle.value ? "z-[101]" : ""
            }`}
        >
          {renderHeader()}
          {renderParticipantInfo()}
        </div>
        {renderMenuTab()}
        <div className="flex-1 overflow-hidden">{renderTab()}</div>
      </div>
    )
  }

  return (
    <div
      className={`relative flex flex-col flex-1 overflow-hidden height-conversation-mobile`}
      style={{
        position: "relative",
      }}
    >
      <div
        className="absolute left-[-1px] bottom-[50%] cursor-pointer hidden md:block"
        onClick={() => {
          collapse.setValue(!collapse.value)
        }}
      >
        {collapse.value ? (
          <CollapseIcon className="collapse-icon" />
        ) : (
          <ExpandIcon className="collapse-icon" />
        )}
      </div>
      <div className="h-full pb-[12px] bg-white">{renderBody()}</div>

      {isToggle.value && isMobile && (
        <div
          className={`block md:hidden fixed w-[100vw] h-[100vh] `}
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            zIndex: 1,
          }}
        ></div>
      )}
      {isWarningEncrypted ? (
        <div className="absolute bottom-0 left-4 right-0 top-12 bg-[#FFFFFF] z-[100]">
          <div className="flex flex-col items-center justify-center h-full">
            <IconLock />
            <p className="text-[14px] text-[#EA4545] leading-[24px] mt-[24px] font-semibold mb-[12px]">
              This conversation is encrypted.
            </p>
            <p className="text-[14px] text-[#111111] leading-[24px]">
              Ask the owner for access to view it.
            </p>
          </div>
        </div>
      ) : null}
    </div>
  )
}
export default ConversationMessagesColumn
